module.exports = __webpack_public_path__ + "static/bg-wolters-5cbc549baebf5574a341f33f27c08559.webp";